import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getOneClickVehiclesState } from '@ordersnproducts/modules/one-click-order/selectors/one-click-vehicles.selector';

export class OneClickPreviewVehiclesLoadingProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickVehiclesState).pipe(
      filter(state => !!state),
      map(state => state.loading),
    );
  }
}
